import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewEncapsulation,
} from '@angular/core';
import {
  NavigationLink,
  NavigationStateData,
} from '@zipari/shared-ds-util-navigation';
import { removeSpecialCharacters } from '@zipari/shared-util-common';
import { stopEvent } from '../../../../shared/utils/event';
import { NavigationService } from '../../navigation.service';

@Component({
  encapsulation: ViewEncapsulation.None, // Turned off to allow overwriting of styles in mobile menu
  selector: 'nav-icons',
  styleUrls: ['./nav-icons.component.scss'],
  templateUrl: './nav-icons.component.html',
})
export class NavIconsComponent {
  @Input() data: NavigationStateData;
  @Output() navItemClicked: EventEmitter<NavigationLink> = new EventEmitter();

  constructor(private navigationService: NavigationService) {}

  public isIconMenuExpanded(icon: string) {
    return !!(this.data.openMenuItem && icon === this.data.openMenuItem.icon);
  }

  public onIconClick(event: Event, icon: NavigationLink): void {
    stopEvent(event);
    this.navItemClicked.emit(icon);
  }

  public onLogoutClick(): void {
    this.navigationService.propagateLogoutClicked$();
  }

  public numbersAndLettersOnly(sourceString: string) {
    return removeSpecialCharacters(sourceString);
  }
}
